import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';
import { TUserRoles } from '@/features/users/schemas/users.schema.ts';
import { AxiosError } from 'axios';

type PostVerify2FAResponse = {
  refreshToken: {
    expiresAt: number;
  };
  role: TUserRoles;
};

type PostVerify2FAErrorResponse = {
  message: string;
  redirectTo: 'LOGIN_PAGE';
};

export const usePostVerify2FAMutation = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (data: PostVerify2FAResponse) => void;
    onError?: (error: AxiosError<PostVerify2FAErrorResponse>) => void;
  } = {
    onSuccess: undefined,
    onError: undefined,
  }
) => {
  return useMutation({
    mutationFn: async ({ totpCode }: { totpCode: string }) => {
      const { data } = await client.post<PostVerify2FAResponse>(`/auth/2fa/totp/verify`, {
        totpCode,
      });

      return data;
    },
    onSuccess,
    onError,
  });
};
